import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import PropTypes from "prop-types"
import { can, VIEW_SCREENER_ROOMS } from "@src/helpers/authorization"
import TeamAccess from "../../../team_access"
import { updateUsersAccess } from "@api/screener_rooms/"

class Members extends Component {
  render() {
    const { screenerRoomID, screenerRoomUsers, roleUsers, updateUsersAccess } = this.props
    return (
      <TeamAccess
        label='Screener room members'
        attachedUsers={screenerRoomUsers}
        roleUsers={roleUsers}
        parentUsers={[]}
        updateUsersAccess={userIDs => updateUsersAccess(screenerRoomID, userIDs)}
      />
    )
  }
}

Members.propTypes = {
  screenerRoomUsers: PropTypes.array,
  roleUsers: PropTypes.array,
}

const mapStateToProps = state => ({
  screenerRoomID: state.screener_rooms.screenerRoom.data?._id,
  screenerRoomUsers: state.screener_rooms.screenerRoom.data?.users || [],
  roleUsers: state.user.auth.organization_id
    ? state.settings.organizations.members.items.filter(user => can(user, [VIEW_SCREENER_ROOMS]))
    : [],
})

const mapDispatchToProps = dispatch => ({
  updateUsersAccess: bindActionCreators(updateUsersAccess, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Members)